export { default as getName } from "./getName";
export { default as getFields } from "./getFields";
export { default as getFieldsV2 } from "./getFieldsV2";
export { default as getInitialValues } from "./getInitialValues";
export { default as getInputType } from "./getInputType";
export { default as validate } from "./validate";
export { default as validateV2 } from "./validateV2";
export { makeBuildSchema, makeSchemaV2 } from "./makeBuildSchema";
export { annotateLinkedDropdowns, resolveFieldTriggers, isFieldVisible, applyVisibilityToSchema } from "./linkedDropdown";
export { splitFieldsIntoPages, pageHasErrors, collectPageFieldNames } from "./paginate";

export const labelName1 = (str) => typeof str === "string" ? str?.replace(/_/g, " ") : "";
export const labelName = (str) => {
  if (typeof str !== "string") return "";
  let name = str?.replace(/_/g, " ") ?? "";
  name = name.split(" ");
  if (name.length > 1) {
    let lastItem = name[name.length - 1];
    if (Number(+lastItem)) {
      name.pop();
    }
    return name.join(" ");
  }
  return name.join(" ");
};

export const getDomain = () => {
  const hostname = window.location.hostname;
  const domain = hostname.split(".");
  return domain[0];
};

export const getTrustedOriginSuffix = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  if (parts.length >= 2) {
    // Returns the root domain (like ".1gov.ng" or ".convergenceondemand.com")
    return `.${parts.slice(-2).join(".")}`;
  }
  return;
};

export function getLastItemOrBefore(str, delimeter = ".") {
  // Trim to remove extra spaces from start and end
  const trimmedStr = str.trim();

  // Check if the string contains a period
  const lastPeriodIndex = trimmedStr.lastIndexOf(delimeter);

  // Case 1: No period found, return the original string
  if (lastPeriodIndex === -1) {
    return trimmedStr;
  }

  // Extract the part after the last period
  const afterPeriod = trimmedStr.slice(lastPeriodIndex + 1).trim();

  // Case 2: Valid text after the period, return it
  if (afterPeriod.length > 0) {
    return afterPeriod;
  }

  // Case 3: No valid text after the last period, return the text before the period
  const beforePeriod = trimmedStr.slice(0, lastPeriodIndex).trim();
  return beforePeriod.length > 0 ? beforePeriod : trimmedStr;
}
